import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Home from './Home';
import Goals from './Goals';
import Calculator from './Calculator';
import NavMenuHeader from './navmenuheadr';
import Blogs from './blogs';
import Footer from './footer';
import BlogPosta from './blogs/bloga';
import { getApps } from "firebase/app";

const App: React.FC = () => {

    if (!getApps().length) {
        console.log('Firebase is not initialized');
    } else {
        console.log('Firebase is initialized');
    }

    return (
        <Router>
            <div className="container-fluid p-0" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1040 }}>
                <NavMenuHeader />
            </div>
            <div style={{ height: '56px' }} /> {/* Spacer to prevent content from being hidden behind navbar */}
            <div className="container-fluid p-0">
            <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/goals" element={<Goals />} />
                    <Route path="/calculator" element={<Calculator />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blogs/firstblog" element={<BlogPosta />} />
                </Routes>
                </div>
            <div className="container-fluid p-0" >
                <Footer />
            </div>

        </Router>
    );
};

export default App;